<div class="loading-wrapper">
    <nz-spin *ngIf="progress === undefined" nzSimple></nz-spin>
    <div *ngIf="progress !== undefined"><nz-progress [nzPercent]="progress" nzType="circle" [nzFormat]="format"></nz-progress></div>
    <div style="margin-top: 20px"><span *ngIf="hoursRemaining">{{ hoursRemaining | number: '1.0-0' }} hours</span><span *ngIf="minutesRemaining">{{ minutesRemaining | number: '1.0-0' }} minute<span *ngIf="minutesRemaining > 1">s</span></span><span *ngIf="secondsRemaining"> {{ secondsRemaining | number: '1.0-0' }} seconds</span> remaining</div>
</div>

